import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getDataReceiveD = () => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_D}` + `/get`);
};
export const billing_expensegetDataReceiveDByID = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_D}` + `/getbyid/${id}`);
};
export const billing_expensegetDataReceiveDByIDOne = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_D}` + `/getbyidone/${id}`);
};
export const billing_expensegetDataPrint = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.TRC_D}` + `/getdataprint/${id}`);
};
export const billing_expenseCreateDataReceiveD = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.TRC_D}` + `/`, data);
};

export const billing_expensedeleteReceiveD = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.TRC_D}` + `/${id}`);
};